

/// <reference path="StockNoteProductLine.ts" />

// Generated class BuyOrderLine_ManagedObject

class BuyOrderLine_ManagedObject extends StockNoteProductLine
{
}
